import React from "react";
import { Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import CustomIcon, { AssetTypes } from "../../../../../../public/icons-v1_1";
import { PathPickLandingCtaAction } from "@/features/pathpick/features/landing/hooks/usePathPickLandingCta";
import { PATHPICK_LANDING_COLORS } from "@/features/pathpick/features/landing/constants";

interface Props {
  action: PathPickLandingCtaAction;
  icon?: AssetTypes;
  // 모서리 — 히어로는 사각(8px), 하단·플로팅 CTA는 알약형(시안).
  shape?: "rounded" | "pill";
  size?: "md" | "lg";
  // 멤버십 응답 전에는 문구를 확정할 수 없다 — 자리만 차지하고 보이지 않게 둔다.
  isPending?: boolean;
}

/**
 * 랜딩의 파란 CTA 버튼.
 *
 * 크롤러가 목적지를 읽을 수 있도록 button이 아니라 실제 `<a href>`(react-router Link)로 낸다.
 */
function PathPickLandingCtaButton({
  action,
  icon,
  shape = "rounded",
  size = "md",
  isPending = false,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <Link
      as={RouterLink}
      to={action.href}
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={"8px"}
      flexShrink={0}
      padding={size === "lg" ? "14px 26px" : "10px 18px"}
      borderRadius={shape === "pill" ? "full" : "8px"}
      background={PATHPICK_LANDING_COLORS.blue}
      color={"#FFFFFF"}
      visibility={isPending ? "hidden" : "visible"}
      _hover={{
        textDecoration: "none",
        background: PATHPICK_LANDING_COLORS.blueHover,
      }}
      _active={{ background: PATHPICK_LANDING_COLORS.blueActive }}
    >
      <Text
        textStyle={size === "lg" ? "body-md-bold" : "body-sm-bold"}
        fontWeight={800}
        color={"#FFFFFF"}
        whiteSpace={"nowrap"}
      >
        {t(action.labelKey, action.labelOptions)}
      </Text>
      {icon && (
        <CustomIcon src={icon} width={24} height={24} color={"#FFFFFF"} />
      )}
    </Link>
  );
}

export default PathPickLandingCtaButton;
